import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  column-gap: ${({ theme }) => theme.space[3]}px;
`;

export const DatePickerWrapper = styled.div`
  width: 140px;
`;

export const TimePickerWrapper = styled.div`
  width: 120px;
`;
